// extracted by mini-css-extract-plugin
module.exports = {"root":"CurrentSong_root__M7pht","loading":"CurrentSong_loading__9eKMV","nowPlaying":"CurrentSong_nowPlaying__YLf_8"};